import {Component, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserInfoModel} from '../../../services/models/user-info.model';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SimulatorService} from '../simulator.service';
import {SimulatorResultModel} from '../models/simulator-result.model';
import {EventsService} from '../../../services/events.service';
import {NavService} from '../../../services/nav.service';
import {trigger, style, animate, transition, state, keyframes} from '@angular/animations';
declare const require: any;

@Component({
    selector: 'simulator-page',
    templateUrl: './simulator.page.html',
    styleUrls: ['./simulator.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        trigger('fadeInFadeOut', [
            transition(':enter', [
                animate('30s', keyframes([
                    style({ opacity: 0, transform: 'scale(0.5)', offset: 0 }),
                    style({ opacity: 1, transform: 'scale(1.2)', offset: 1 }),
                ])),
            ]),
            transition(':leave', [
                animate('1s', keyframes([
                    style({ opacity: 1, transform: 'scale(1.2)', offset: 0 }),
                    style({ opacity: 0, transform: 'scale(1.2)', offset: 1 }),
                ])),
            ])

        ]),
    ]
})

export class SimulatorPage implements OnInit {

    loading = true;
    showPoints = false;
    points = 0;

    endpoints = {
        "TDM": "https://alchemist-client.speakeasy-client.pages.dev/experiences/01GK6ZE3063RNBZ75P4E2VJHBJ",
        "EDM-HIGH": "https://alchemist-client.speakeasy-client.pages.dev/experiences/01GKRTDKCRAB9KMG9PCG6R4999?features=%5B%7B%22type%22%3A%22skip-intro%22%2C%22enabled%22%3Atrue%7D%2C%7B%22type%22%3A%22start-intent%22%2C%22enabled%22%3Atrue%2C%22properties%22%3A%7B%22event%22%3A%22EDM-HIGH%22%7D%7D%5D",
        "EDM-MEDIUM": "https://alchemist-client.speakeasy-client.pages.dev/experiences/01GKRTDKCRAB9KMG9PCG6R4999?features=%5B%7B%22type%22%3A%22skip-intro%22%2C%22enabled%22%3Atrue%7D%2C%7B%22type%22%3A%22start-intent%22%2C%22enabled%22%3Atrue%2C%22properties%22%3A%7B%22event%22%3A%22EDM-MEDIUM%22%7D%7D%5D",
        "EDM-LOW": "https://alchemist-client.speakeasy-client.pages.dev/experiences/01GKRTDKCRAB9KMG9PCG6R4999?features=%5B%7B%22type%22%3A%22skip-intro%22%2C%22enabled%22%3Atrue%7D%2C%7B%22type%22%3A%22start-intent%22%2C%22enabled%22%3Atrue%2C%22properties%22%3A%7B%22event%22%3A%22EDM-LOW%22%7D%7D%5D",
    }

    next_game = "TDM";
    next_game_trigger = {
        "START": "TDM",
        "TDM-XH-OH": "EDM-HIGH",
        "TDM-XH-OM": "EDM-MEDIUM",
        "TDM-XM-OM": "EDM-MEDIUM",
        "TDM-XL-OM": "EDM-MEDIUM",
        "TDM-XL-OL": "EDM-LOW",
        "TDM-XM-OL": "EDM-LOW",
        "EDM-XH-OH": "FINISH-HIGH",
        "EDM-XH-OM": "FINISH-MEDIUM",
        "EDM-XM-OM": "FINISH-MEDIUM",
        "EDM-XM-OL": "FINISH-LOW",
        "EDM-XL-OL": "FINISH-LOW"
    };

    start_game = [
        "TDM-NULL-RH", "TDM-NULL-RL", "EDM-WH-RH", "EDM-WH-RM", "EDM-WM-RM", "EDM-WM-RL", "EDM-WL-RL", "EDM-WL-WL"
    ];

    scoring = {
        "EDM-AH-SH": 900,
        "EDM-AH-SL": 700,
        "EDM-AH-SM": 800,
        "EDM-AL-AL": 0,
        "EDM-AL-SL": 100,
        "EDM-AL-SM": 200,
        "EDM-AM-SH": 700,
        "EDM-AM-SL": 500,
        "EDM-AM-SM": 600,
        "EDM-CH-UH": 900,
        "EDM-CH-UL": 700,
        "EDM-CH-UM": 800,
        "EDM-CL-CL": 0,
        "EDM-CL-UL": 100,
        "EDM-CL-UM": 200,
        "EDM-CM-CH": 700,
        "EDM-CM-UL": 500,
        "EDM-CM-UH": 600,
        "EDM-CM-UM": 600,
        "EDM-D1H-D2H": 600,
        "EDM-D1H-D2L": 100,
        "EDM-D1H-D2M": 500,
        "EDM-D1L-D1L": 0,
        "EDM-D1L-D2L": 100,
        "EDM-D1L-D2M": 200,
        "EDM-D1M-D2H": 700,
        "EDM-D1M-D2L": 500,
        "EDM-D1M-D2M": 600,
        "EDM-D2H-AH": 900,
        "EDM-D2H-AL": 700,
        "EDM-D2H-AM": 200,
        "EDM-D2L-AL": 100,
        "EDM-D2L-D2L": 0,
        "EDM-D2L-D2M": 300,
        "EDM-D2M-AL": 500,
        "EDM-D2M-AM": 600,
        "EDM-D2M-D2H": 700,
        "EDM-RH-D1H": 900,
        "EDM-RH-D1M": 800,
        "EDM-RL-D1L": 700,
        "EDM-RL-D1M": 500,
        "EDM-RM-D1H": 600,
        "EDM-RM-D1M": 500,
        "EDM-SH-CH": 900,
        "EDM-SH-CL": 700,
        "EDM-SH-CM": 800,
        "EDM-SL-CL": 100,
        "EDM-SL-CM": 200,
        "EDM-SL-SL": 0,
        "EDM-SM-CH": 700,
        "EDM-SM-CL": 500,
        "EDM-SM-CM": 600,
        "EDM-UH-XH": 900,
        "EDM-UH-XL": 700,
        "EDM-UH-XM": 800,
        "EDM-UL-UL": 0,
        "EDM-UL-XL": 100,
        "EDM-UL-XM": 200,
        "EDM-UM-XH": 700,
        "EDM-UM-XL": 500,
        "EDM-UM-XM": 600,
        "EDM-WH": 0,
        "EDM-WH-RH": 900,
        "EDM-WH-RM": 600,
        "EDM-WL": 0,
        "EDM-WL-RL": 200,
        "EDM-WL-WL": 0,
        "EDM-WM": 0,
        "EDM-WM-RL": 300,
        "EDM-WM-RM": 500,
        "EDM-XH-OH": 2000,
        "EDM-XH-OM": 500,
        "EDM-XL-OL": 300,
        "EDM-XL-XL": 0,
        "EDM-XM-OM": 700,
        "TDM-CH-UH": 900,
        "TDM-CH-UL": 700,
        "TDM-CH-UM": 800,
        "TDM-CL-CL": 0,
        "TDM-CL-UL": 200,
        "TDM-CL-UM": 300,
        "TDM-CM-UH": 600,
        "TDM-CM-UL": 400,
        "TDM-CM-UM": 500,
        "TDM-D1H-D2H": 900,
        "TDM-D1H-D2L": 700,
        "TDM-D1H-D2M": 800,
        "TDM-D1L-D2H": 300,
        "TDM-D1L-D2L": 100,
        "TDM-D1L-D2M": 200,
        "TDM-D2H-CH": 900,
        "TDM-D2H-CM": 800,
        "TDM-D2H-D2M": 700,
        "TDM-D2L-CL": 200,
        "TDM-D2L-D2L": 0,
        "TDM-D2L-D2M": 300,
        "TDM-D2M-CL": 400,
        "TDM-D2M-CM": 500,
        "TDM-NULL-RH": 300,
        "TDM-NULL-RL": 100,
        "TDM-RH-D1H": 900,
        "TDM-RH-D1L": 300,
        "TDM-RL-D1L": 100,
        "TDM-RL-RH": 300,
        "TDM-UH-XH": 900,
        "TDM-UH-XL": 700,
        "TDM-UH-XM": 800,
        "TDM-UL-UL": 0,
        "TDM-UL-XL": 200,
        "TDM-UL-XM": 300,
        "TDM-UM-XH": 600,
        "TDM-UM-XL": 400,
        "TDM-UM-XM": 500,
        "TDM-XH-OH": 2000,
        "TDM-XH-OM": 800,
        "TDM-XL-OL": 100,
        "TDM-XL-OM": 500,
        "TDM-XM-OL": 100,
        "TDM-XM-OM": 500
    }

    started_at = null;
    score = 0;
    questions = null;
    questions_unique = null;
    last_question = null;

    type = null;
    userInfo: UserInfoModel = null;
    url = null;
    simSrc = null;
    simHost = 'https://alchemist-client.speakeasy-client.pages.dev';
    messages: any[] = [];
    step = 'background';

    onMessage = null;

    result: SimulatorResultModel = null;

    constructor(
        public sanitizer: DomSanitizer,
        public userService: UserService,
        private simulatorService: SimulatorService,
        private route: ActivatedRoute,
        private router: Router,
        private event: EventsService,
        private linkSystem: NavService,
    ) {
    }

    ngOnInit() {
        this.loading = true;
        this.type = this.route.snapshot.data.type;
        this.simulatorService.getMySimulatorResult()
            .then((result) => {
                this.result = result;
                if (this.type === 'edm' && !!this.endpoints[this.result.tdm_result]) {
                    this.url = this.endpoints[this.result.tdm_result];
                    this.next_game = this.result.tdm_result;
                } else if (this.type === 'tdm') {
                    this.url = this.endpoints['TDM'];
                }

                this.loading = false;
            })
    }

    displayPoints(points) {
        this.points = points;
        this.showPoints = true;
        setTimeout(() => {
            this.showPoints = false;
        }, 2000);
    }

    runGame() {
        if (!this.url) return;

        this.messages = [];
        this.questions = [];

        this.onMessage = this.listener.bind(this);
        window.addEventListener('message', this.onMessage, false);

        this.initIframe();
        // this.initConvo();
        this.event.publish('form:changed', 'sim');

        this.started_at = new Date();
        this.simulatorService.saveMySimulatorResult(this.type, [], this.next_game, 0, this.started_at)
            .then((result) => {
            });

        this.step = 'sim';
    }

    initConvo() {
        const anchor = document.createElement('a')
        anchor.href = this.url;
        anchor.innerHTML = '<span>Visit Forever Holdings</span>'

        const link = document.createElement('link')
        link.href = 'https://unpkg.com/@intheroomglobal/embed/dist/embed.min.css'
        link.rel = 'stylesheet'

        const script = document.createElement('script')
        script.src = 'https://unpkg.com/@intheroomglobal/embed/dist/embed.min.js'

        const convo = document.createElement('convo')
        convo.dataset.aspectRatio = '1:1'
        convo.append(link, anchor, script)

        document.querySelector('body simulator-page ion-content').appendChild(convo)
    }

    stopGame(next_game) {
        window.removeEventListener("message", this.onMessage, false);
        this.event.publish('form:saved', 'sim');

        this.score = this.questions.reduce((acc, q) => acc + q.score, 0);

        if (next_game === 'EXIT') {
            this.step = 'background';
        } else {
            this.next_game = next_game;
            this.step = 'results';
        }

        this.loading = true;
        this.simulatorService.saveMySimulatorResult(this.type, this.questions, next_game, this.score, this.started_at)
            .then((result) => {
                this.result = result;
                this.loading = false;
            });
    }

    goToSimulatorTDM() {
        this.router.navigate(['/simulator/tdm']);
    }

    goToSimulatorEDM() {
        this.router.navigate(['/simulator/edm']);
    }

    goToLeaderboard() {
        this.router.navigate(['/leaderboard']);
    }

    initIframe(){
        this.simSrc = this.sanitizer.bypassSecurityTrustHtml("<body style='margin: 0'>\n" +
            "            <convo data-aspect-ratio=\"4:3\">\n" +
            "        <link href=\"https://unpkg.com/@intheroomglobal/embed/dist/embed.min.css\" rel=\"stylesheet\" />\n" +
            "        <a href=\"" + this.url + "\" id=\"run_experience\"><span>Loading...</span></a>\n" +
            "        <script src=\"https://unpkg.com/@intheroomglobal/embed/dist/embed.min.js\"></script>\n" +
            "            </convo>\n" +
            "            <script>setTimeout(()=>document.getElementById('run_experience').click(), 1000);</script>\n" +
            "            </body>");
    }

    listener(e: MessageEvent<any>) {
        console.log('Message',{
            type: e.type,
            message: e.data,
        });

        this.messages.push(e.data);

        if (!!e.data.name) {
            if (e.data.name === "speakeasy:question_asked") {
                console.log('question_asked', e.data.data?.matched_intent, e.data.data?.payload)

                if (this.next_game_trigger.hasOwnProperty(this.last_question)) {
                    this.stopGame(this.next_game_trigger[this.last_question]);
                } else {
                    this.registerQuestion(e.data);

                    // "speakeasy:video_started"
                    // "speakeasy:video_stopped"
                    if (e.data.data?.matched_intent) {
                        this.last_question = e.data.data?.matched_intent;
                    }
                }
            }
            if (e.data.name === "speakeasy:video_stopped") {
                console.log('video_stopped')

                if (this.next_game_trigger.hasOwnProperty(this.last_question)) {
                    this.stopGame(this.next_game_trigger[this.last_question]);
                }
            }
            if (e.data.name === "speakeasy:close_clicked") {
                this.stopGame('EXIT');
            }
        }
    }

    public registerQuestion(message) {

        const code = message.data?.matched_intent ? message.data?.matched_intent : null;

        if (this.start_game.includes(code)) {
            this.questions.forEach(q => q.score = 0);
        }

        const score = (
            code !== null
            && this.scoring.hasOwnProperty(code)
        ) ? this.scoring[code] : 0;

        const question = {
            code: code,
            score: score,
            data: message.data,
        }

        this.questions.push(question);

        this.simulatorService.saveMySimulatorProgress(this.type, question).then((result) => {
            if (score > 0) {
                this.displayPoints(score);
            }
        });
    }

    goToHelpDesk() {
        this.linkSystem.toLink('https://alchemist-techsupport.freshdesk.com/support/tickets/new');
    }

    public ngOnDestroy() {
        console.log('remove listener ngOnDestroy')
        window.removeEventListener("message", this.onMessage, false);
    }
}
